<template>
    <section class="home-page__04" @click.self="closeWrap">
        <img class="title" src="../../assets/images/home/page04/title.png" alt="title">
            <div class="character_wrap">
                <template v-for="(item, index) in characterList">
                    <img v-if="index == 0" v-show="activeStaticIndex == -1" class="character_shadow" src="../../assets/images/home/page04/shadow.png" :key="`firstShadow-${index}`" alt="">
                    <div :class="`character_container character_container-${index}`" :key="index">
                        <transition :name="slideType(index)">
                            <div class="character_box" v-show="showCharacter" @click="showDetail(index)">
                                <img v-show="activeStaticIndex !== index" class="character_staticimg" :src="item.static" alt="">
                            </div>
                        </transition>
                        <transition-group name="character_opacity" tag="div" >
                            <img v-show="character_big_show" :class="['character_staticimg_big', { 'active_staticimg': activeStaticIndex == index }]" :src="item.staticImg" alt="" key="staticimg">
                            <!-- spine -->
                            <div v-show="spineloadedArr.indexOf(index + 1) !== -1 && spine_show && activeStaticIndex == index" :id="`character_spine-${index}`" class="active_spine" key="spine"></div>
                        </transition-group>
                    </div>
                    <img v-show="activeStaticIndex == -1" class="character_shadow" src="../../assets/images/home/page04/shadow.png" :key="`shaodow-${index}`" alt="">

                    <transition name="characterbg" :key="`msg-${index}`">
                        <div class="character_bg"  v-if="activeStaticIndex !== -1" :style="`background: url(${characterList[activeStaticIndex].bgImg})`">
                        </div>
                    </transition>
                </template>
                <transition name="character_slide"> 
                    <div class="character_msg-mask" v-if="activeStaticIndex !== -1">
                        <span class="character_close-btn iconguanbi iconfont" @click="closeCharacterMask"></span>
                        <div class="character_msg">
                            <div class="character_msg--class-container">
                                <img class="character_msg-name" :src="characterList[activeStaticIndex].nameImg" alt="">
                                <img :src="characterList[activeStaticIndex].cvImg" alt="" class="character_msg-cv">
                                <img class="character_msg-class" :src="characterList[activeStaticIndex].classImg" alt="">
                            </div>
                            <div class="character_msg--detail-container">
                                <img :src="characterList[activeStaticIndex].detailImg" alt="" class="character_msg--detail">
                                <img src="../../assets/images/home/page04/coming.png" alt="" class="pv-com">
                            </div>
                        </div>
                        <img :class="['character_msg-word', `character_msg-word-${activeStaticIndex}`]" :src="characterList[activeStaticIndex].wordImg" alt="">
                    </div>
                </transition>
            </div>

        <img src="../../assets/images/home/page04/bg_mask.png" class="bg_mask" @click="closeWrap" alt="">
        <scroll-bar></scroll-bar>
        <pre-login></pre-login>
    </section>
</template>

<script>
import scrollBar from "../../components/scroll-bar";
import preLogin from "../../components/pre-login";
import { spine } from "../../plugins/spine-player.js"

export default {
    name: "home-page04",

    components: {
        "scroll-bar": scrollBar,
        "pre-login": preLogin,
    },
    data: () => ({
        firstShow: true,
        showCharacter: false,       // 角色显示参数
        activeStaticIndex: -1,      // 显示角色详细参数
        characterList: [
            {
                static: require("../../assets/images/home/page04/character01/character01_static.png"),
                staticImg: require("../../assets/images/home/page04/character01/character01.png"),
                bgImg: require("../../assets/images/home/page04/character01/modal_bg.png"),
                nameImg: require("../../assets/images/home/page04/character01/name.png"),
                cvImg: require("../../assets/images/home/page04/character01/character_cv.png"),
                classImg: require("../../assets/images/home/page04/character01/class.png"),
                detailImg: require("../../assets/images/home/page04/character01/character_details.png"),
                wordImg: require("../../assets/images/home/page04/character01/word.png")
            },
            {
                static: require("../../assets/images/home/page04/character02/character02_static.png"),
                staticImg: require("../../assets/images/home/page04/character02/character02.png"),
                bgImg: require("../../assets/images/home/page04/character02/modal_bg.png"),
                nameImg: require("../../assets/images/home/page04/character02/name.png"),
                cvImg: require("../../assets/images/home/page04/character02/character_cv.png"),
                classImg: require("../../assets/images/home/page04/character02/class.png"),
                detailImg: require("../../assets/images/home/page04/character02/character_details.png"),
                wordImg: require("../../assets/images/home/page04/character02/word.png")
            },
            {
                static: require("../../assets/images/home/page04/character03/character03_static.png"),
                staticImg: require("../../assets/images/home/page04/character03/character03.png"),
                bgImg: require("../../assets/images/home/page04/character03/modal_bg.png"),
                nameImg: require("../../assets/images/home/page04/character03/name.png"),
                cvImg: require("../../assets/images/home/page04/character03/character_cv.png"),
                classImg: require("../../assets/images/home/page04/character03/class.png"),
                detailImg: require("../../assets/images/home/page04/character03/character_details.png"),
                wordImg: require("../../assets/images/home/page04/character03/word.png")
            },
            {
                static: require("../../assets/images/home/page04/character04/character04_static.png"),
                staticImg: require("../../assets/images/home/page04/character04/character04.png"),
                bgImg: require("../../assets/images/home/page04/character04/modal_bg.png"),
                nameImg: require("../../assets/images/home/page04/character04/name.png"),
                cvImg: require("../../assets/images/home/page04/character04/character_cv.png"),
                classImg: require("../../assets/images/home/page04/character04/class.png"),
                detailImg: require("../../assets/images/home/page04/character04/character_details.png"),
                wordImg: require("../../assets/images/home/page04/character04/word.png")
            },
            {
                static: require("../../assets/images/home/page04/character05/character05_static.png"),
                staticImg: require("../../assets/images/home/page04/character05/character05.png"),
                bgImg: require("../../assets/images/home/page04/character05/modal_bg.png"),
                nameImg: require("../../assets/images/home/page04/character05/name.png"),
                cvImg: require("../../assets/images/home/page04/character05/character_cv.png"),
                classImg: require("../../assets/images/home/page04/character05/class.png"),
                detailImg: require("../../assets/images/home/page04/character05/character_details.png"),
                wordImg: require("../../assets/images/home/page04/character05/word.png")
            },
            {
                static: require("../../assets/images/home/page04/character06/character06_static.png"),
                staticImg: require("../../assets/images/home/page04/character06/character06.png"),
                bgImg: require("../../assets/images/home/page04/character06/modal_bg.png"),
                nameImg: require("../../assets/images/home/page04/character06/name.png"),
                cvImg: require("../../assets/images/home/page04/character06/character_cv.png"),
                classImg: require("../../assets/images/home/page04/character06/class.png"),
                detailImg: require("../../assets/images/home/page04/character06/character_details.png"),
                wordImg: require("../../assets/images/home/page04/character06/word.png")
            },
            {
                static: require("../../assets/images/home/page04/character07/character07_static.png"),
                staticImg: require("../../assets/images/home/page04/character07/character07.png"),
                bgImg: require("../../assets/images/home/page04/character07/modal_bg.png"),
                nameImg: require("../../assets/images/home/page04/character07/name.png"),
                cvImg: require("../../assets/images/home/page04/character07/character_cv.png"),
                classImg: require("../../assets/images/home/page04/character07/class.png"),
                detailImg: require("../../assets/images/home/page04/character07/character_details.png"),
                wordImg: require("../../assets/images/home/page04/character07/word.png")
            }
        ],
        character_big_show: true,      
        spine_show: false,
        spineobj: null,     // spine对象
        spineTiemr: null,   // spine定时器
        spineloadedArr: [], // spine已加载序列
        spineList: [
            {
                name: "c1049",
                skin: "normal"
            },
            {
                name: "c1011",
                skin: ""
            },
            {
                name: "c1005",
                skin: ""
            },
            {
                name: "c1001",
                skin: "smile"
            },
            {
                name: "c1007",
                skin: "sad"
            },
            {
                name: "c1062",
                skin: "normal"
            },
            {
                name: "c1024",
                skin: "special"
            }
        ]
    }),
    created() {
        
    },
    mounted() {

    },
    watch: {
        NAV_ACTIVE_INDEX(val) {
            if(val == 4 && this.firstShow) {
                this.firstShow = false;
                setTimeout(() => {
                    this.showCharacter = true;
                }, 1500)
            }
        },
    },
    computed: {
        NAV_ACTIVE_INDEX() {		// 导航栏激活指数
            if(this.$store.state.HOME_FULLPAGE) {       // 异步对象
                return this.$store.state.HOME_FULLPAGE.activeIndex;
            } else {
                return -1;
            }
        },
    },
    methods: {
        closeWrap() {
            if(this.activeStaticIndex !== -1) {
                this.closeCharacterMask();
            }
        },
        closeCharacterMask() {
            setTimeout(() => {
                this.showCharacter = true       
            }, 1000)
            this.activeStaticIndex = -1
            this.character_bg_show = false
            // spine
            clearInterval(this.spineTiemr)
            this.character_big_show = true
            this.spine_show = false;
            this.spineobj = null
        },
        slideType(index) {
            if(index%2 == 0) {
                return "slideTop"
            } else {
                return "slideBottom"
            }
        },
        showDetail(index) {
            this.showCharacter = false
            this.activeStaticIndex = index
            this.character_bg_show = true

            // spine
            if(this.spineloadedArr.indexOf(index + 1) === -1) {
                setTimeout(() => {
                    this.setSpine(index + 1)
                }, 50)
            } else {
                setTimeout(() => {
                    this.character_big_show = false;
                    this.spine_show = true;
                }, 500)
            }
        },
        setSpine(index) {
            this.spineobj = new spine.SpinePlayer(`character_spine-${index - 1}`, {
                jsonUrl: `${process.env.VUE_APP_PUBLICPATH}/spine/character0${index}/${this.spineList[index-1].name}.json`,
                atlasUrl: `${process.env.VUE_APP_PUBLICPATH}/spine/character0${index}/${this.spineList[index-1].name}.atlas`,
                animation: "idle",
                skin: `${this.spineList[index-1].skin}`,
                showControls: false,        // 隐藏控件
                premultipliedAlpha: true,
                backgroundColor: "#00000000",
                alpha: true,
                viewport: {
                    debugRender: false,
                    padLeft:"0%",
                    padRight:"0%",
                    padTop:"0%",
                    padBottom:"0%",		
                }
            });
            this.spineTiemr = setInterval(() => {
                if(this.spineobj && this.spineobj.loaded) {
                    console.log(`[${this.spineobj.parent.getAttribute('id')}] already loaded..`)
                    this.spineloadedArr.push(index);
                    this.spine_show = true;
                    this.character_big_show = false;     // 隐藏立绘大图
                    clearInterval(this.spineTiemr);
                }
            }, 2000)
        }
    },
    destroyed() {
        if(this.spineTiemr) {
            clearInterval(this.spineTiemr);
        }
    }
};
</script>

<style lang="scss" scoped>
.home-page__04 {
    overflow: hidden;
    position: relative;
    background: url("../../assets/images/home/page04/bg.png") no-repeat;
    background-size: cover;
    background-position: center 45%;

    .title {
        position: absolute;
        z-index: 5;
        height: 100%;
        left: pxTorem(27px);
        opacity: 0.8;
    }
        
    .character_wrap {
        width: pxTorem(1500px);
        height: pxTorem(600px);
        // background: pink;
        position: relative;
        // margin-top: pxTorem(90px);
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 3;
        display: flex;
        flex-direction:row;

        .character_container {
            flex: 1;
            position: relative;
            
            .character_box {
                width: 100%;
                height: 100%;
                position: relative;
                overflow: hidden;
                box-sizing: border-box;
                cursor: pointer;
                background: linear-gradient(to top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.4) 10%, rgba(255, 255, 255, 0));

                &::after {
                    content: "";
                    display: block;
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    background: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4) 10%, rgba(0, 0, 0, 0));
                }

                &:hover::after {
                    opacity: 0;
                }
                
                .character_staticimg {
                    // height: 140%;
                    width: 100%;
                    position: absolute;
                }
            }

            .character_staticimg_big {
                height: 140%;
                position: absolute;
                opacity: 0;
                z-index: -1;
                transition: all .3s;
            }
            #character_spine {
                z-index: -1;
            }
            &.character_container-0 .character_staticimg {
                bottom: 0;
            }
            &.character_container-0 .character_staticimg_big {
                left: -82%;
                top: -3%;

                &.active_staticimg {
                    z-index: 4;
                    opacity: 1;
                    height: 197%;
                    top: -28%;
                    left: 29%;
                }
            }
            &.character_container-0 .active_spine {
                width: 706%;
                height: 254%;
                top: -75%;
                left: -143%;
                position: absolute;
                z-index: 4 !important;
            }
            &.character_container-1 .character_staticimg {
                bottom: 0;
            }
            &.character_container-1 .character_staticimg_big {
                left: -24%;
                top: 13%;

                &.active_staticimg {
                    z-index: 4;
                    opacity: 1;
                    height: 225%;
                    top: -13%;
                    left: -17%;
                }
            }
            &.character_container-1 .active_spine {
                width: 550%;
                height: 229%;
                top: -17%;
                left: -105%;
                position: absolute;
                z-index: 4 !important;
            }
            &.character_container-2 .character_staticimg {
                bottom: -3%;
            }
            &.character_container-2 .character_staticimg_big {
                left: -100%;
                top: 13.5%;

                &.active_staticimg {
                    z-index: 4;
                    opacity: 1;
                    height: 225%;
                    top: -14%;
                    left: -222%;
                }
            }
            &.character_container-2 .active_spine {
                width: 580%;
                height: 240%;
                top: -17%;
                left: -252%;
                position: absolute;
                z-index: 4 !important;
            }
            &.character_container-3 .character_staticimg {
                bottom: 0;
            }
            &.character_container-3 .character_staticimg_big {
                height: 148%;
                left: -107%;
                top: 11%;

                &.active_staticimg {
                    z-index: 4;
                    opacity: 1;
                    height: 222%;
                    top: -18%;
                    left: -319%;
                }
            }
            &.character_container-3 .active_spine {
                width: 571%;
                height: 229%;
                top: -20%;
                left: -363%;
                position: absolute;
                z-index: 4 !important;
            }
            &.character_container-4 .character_staticimg {
                bottom: -3%;
            }
            &.character_container-4 .character_staticimg_big {
                height: 150%;
                left: -109%;
                top: 10%;
                &.active_staticimg {
                    z-index: 4;
                    opacity: 1;
                    height: 240%;
                    top: -19%;
                    left: -421%;
                }
            }
            &.character_container-4 .active_spine {
                width: 580%;
                height: 240%;
                top: -21%;
                left: -492%;
                position: absolute;
                z-index: 4 !important;
            }
            &.character_container-5 .character_staticimg {
                bottom: 0;
            }
            &.character_container-5 .character_staticimg_big {
                left: -60%;
                top: 9%;
                &.active_staticimg {
                    z-index: 4;
                    opacity: 1;
                    height: 190%;
                    top: -21%;
                    left: -439%;
                }
            }
            &.character_container-5 .active_spine {
                width: 455%;
                height: 200%;
                top: -25%;
                left: -476%;
                position: absolute;
                z-index: 4 !important;
            }
            &.character_container-6 .character_staticimg {
                bottom: 0;
            }
            &.character_container-6 .character_staticimg_big {
                left: -78%;
                top: 11%;
                &.active_staticimg {
                    z-index: 4;
                    opacity: 1;
                    height: 215%;
                    top: -22%;
                    left: -557%;
                }
            }
            &.character_container-6 .active_spine {
                width: 420%;
                height: 219%;
                top: -23%;
                left: -580%;
                position: absolute;
                z-index: 4 !important;
            }
        }

        .character_bg {
            width: pxTorem(982px);
            height: pxTorem(617px);
            background-position: center 10% !important;
            background-size: cover;
            position: absolute;
            bottom: 0;
            left: 55%;
            transform: translateX(-50%);
            z-index: 3;
        }

        .character_msg-mask {
            width: pxTorem(982px);
            height: pxTorem(617px);
            position: absolute;
            bottom: 0;
            left: 55%;
            transform: translateX(-50%);
            z-index: 4;
            background: linear-gradient(to left, #fff, rgba(255, 255, 255, 0.45) 30%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 70%);

            .character_close-btn {
                position: absolute;
                bottom: 101%;
                color: #fff;
                font-size: pxTorem(35px);
                right: 0;
                cursor: pointer;
            }

            .character_msg {
                width: pxTorem(560px);
                position: absolute;
                top: pxTorem(40px);
                height: pxTorem(537px);
                right: pxTorem(34px);
                text-align: right;
                display: flex;
                flex-direction: column;
                z-index: 4;

                &--class-container {
                    width: pxTorem(445px);
                    align-self: flex-end;

                    .character_msg-name {
                        width: 100%;
                        margin-bottom: pxTorem(20px);
                    }
                    .character_msg-cv {
                        width: 50%;
                        margin-bottom: pxTorem(20px);
                    }
                    .character_msg-class {
                        width: 85%;
                        margin-bottom: pxTorem(20px);
                    }
                }
                &--detail-container {
                    flex: 1;
                    border-top: 1px dashed #383838;
                    box-sizing: border-box;
                    padding: pxTorem(10px) 0 0 pxTorem(10px);

                    .character_msg--detail {
                        width: 100%;
                        margin-bottom: pxTorem(20px);
                    }
                    .pv-com {
                        width: pxTorem(300px);
                    }
                }
            }
            .character_msg-word {
                position: absolute;
                bottom: 0;
                left: -20%;
                width: pxTorem(150px);

                &-1 {
                    width: pxTorem(170px);
                }

                &-2 {
                    left: -22%;
                    width: pxTorem(175px);
                }

                &-3 {
                    left: -22%;
                    width: pxTorem(170px);
                }
                &-4 {
                    left: -19%;
                    width: pxTorem(170px);
                }

                &-5 {
                    width: pxTorem(177px);
                    bottom: pxTorem(-20px);
                    left: -27%;
                }
                &-6 {
                    width: pxTorem(170px);
                }
            }
        }
    }

    .bg_mask {
        position: absolute;
        width: 100%;
        bottom: 0;
        z-index: 3;
    }

    .slideTop-enter-active, .slideTop-leave-active {
        transition: all 1s;
    }
    .slideTop-enter, .slideTop-leave-to {
        transform: translateY(-50%);
        opacity: 0;
    }
    .slideBottom-enter-active, .slideBottom-leave-active {
        transition: all 1s;
    }
    .slideBottom-enter, .slideBottom-leave-to {
        transform: translateY(50%);
        opacity: 0;
    }


    .characterbg-enter-active, .characterbg-leave-active {
        transition: all 1s;
    }
    .characterbg-enter, .characterbg-leave-to {
        left: 15% !important;
        width: 0 !important;
    }

    .character_slide-enter-active, .character_slide-leave-active {
        transition: all 1s;
        transition-delay: .5s;
    }
    .character_slide-enter, .character_slide-leave-to {
        transform: translateX(-50%) translateY(200px) !important;
        opacity: 0;
    }
    .character_opacity-enter-active{
        transition: opacity .5s !important;
    }
    .character_opacity-leave-active  {
        transition: opacity .5s !important;
    }
    .character_opacity-enter, .character_opacity-leave-to {
        opacity: 0 !important;
    }
}
</style>
